// Currency Context for global currency management
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCurrencySymbol, formatPrice } from '../utils/currency';
import authService from '../services/auth';

const CurrencyContext = createContext();

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState('INR');
  const [currencySymbol, setCurrencySymbol] = useState('₹');

  // Load currency from tenant data when component mounts
  useEffect(() => {
    const loadCurrency = () => {
      try {
        const tenant = authService.getTenant();
        if (tenant && tenant.currency) {
          setCurrency(tenant.currency);
          setCurrencySymbol(getCurrencySymbol(tenant.currency));
        }
      } catch (error) {
        console.error('Error loading currency:', error);
      }
    };

    loadCurrency();
  }, []);

  // Update currency (useful for when tenant data changes)
  const updateCurrency = (newCurrency) => {
    setCurrency(newCurrency);
    setCurrencySymbol(getCurrencySymbol(newCurrency));
  };

  // Format price with current currency
  const formatCurrencyPrice = (amount) => {
    return formatPrice(amount, currency);
  };

  const value = {
    currency,
    currencySymbol,
    updateCurrency,
    formatPrice: formatCurrencyPrice,
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};
